import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../../Utils/i18next/i18next";

export const onSubmit = async (values, props) => {
  const { loadData, update, initialValues, handleHide } = props;

  const data = Object.keys(initialValues)
    .map((key) => {
      const originalItem = initialValues[key];
      const formValue = values?.[key];

      if (!originalItem?.name) return null;

      const newValue =
        formValue && typeof formValue === "object" && formValue.value
          ? formValue.value.value
          : undefined;

      return {
        ...originalItem,
        value:
          newValue !== undefined
            ? newValue
            : originalItem?.value?.value ?? originalItem?.value,
      };
    })
    .filter(Boolean);

  if (update) {
    const res = await GlobalAuthFetch({
      path: "/settings",
      method: "PATCH",
      data,
    });

    const payload = res?.payload;

    if (payload?.status >= 300 || !payload?.status) {
      props.setErrorHeader(0, true);
      props.setErrorHeader(1, true);
      return;
    }
  }

  props.setErrorHeader(0, false);
  props.setErrorHeader(1, false);

  loadData();
  NotificationManager.success(i18n.t("global:success"));
  handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};
  const errorsStep1 = {};

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }
  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }

  return { ...errorsStep0, ...errorsStep1 };
};
